module.exports = __webpack_public_path__ + "img/495.7ede5a17.png";